import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit'
import * as endpoints from '../networkUtility/endpoints';
import * as localStorageActiontype from '../LocalStorage/ActionTypes';
import { getLocalStorage } from '../LocalStorage/GetLocalStorage';

import { toggleNotificationVisibility } from './networkNotification';
import { NotificationType } from '../Utility/InterFacesAndEnum';
import { toggleLoader } from './loader'
import { handle401Status } from '../Utility/Utility';
import { error } from 'console';

interface UsersStateType {
    users: any,
    userAmount: any,
    useDetail: any

}

interface SetUserListProps {
    data: any[]
}

const usersInitialState: UsersStateType = {
    users: [],
    userAmount: [],
    useDetail: {}
}


export const getUserList = createAsyncThunk(
    'get users list',
    async (payload: string, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(`${endpoints.getUserList}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {

                if (response.statusCode === 401) {
                    handle401Status();
                }

                dispatch(setUserList({
                    data: response.result
                }));
            })
            .catch((error) => {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "Something went wrong"
                }));
            })
            .finally(() => {
                dispatch(toggleLoader({
                    isLoading: false
                }));
            })
    }
);

export const getUserDetails = createAsyncThunk(
    'get user details',
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({ isLoading: true }));
        await fetch(`${endpoints.getUserById}${payload}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        }).then((response) => {
            dispatch(toggleLoader({ isLoading: false }));

            return response.json();
        }).then((data) => {
            console.log(data)
            if (data.statusCode === 200) {
                // dispatch(toggleNotificationVisibility({
                //     isVisible: true,
                //     status: NotificationType.success,
                //     message: "User Details Fetch Successfully!"
                // }))
                dispatch(setUserDetails({
                    data: data.result
                }))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "Something went wrong."
                }))
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            dispatch(toggleLoader({ isLoading: false }));

        })
    }
)

export const getUserAmount = createAsyncThunk(
    'get users list',
    async (payload, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(`${endpoints.getUserList}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {

                if (response.statusCode === 401) {
                    handle401Status();
                }
                console.log(response)
                if (response.statusCode === 200) {
                    dispatch(setUserAmount({
                        data: response.result
                    }));
                }
            })
            .catch((error) => {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: "Something went wrong"
                }));
            })
            .finally(() => {
                dispatch(toggleLoader({
                    isLoading: false
                }));
            })
    }
);

export const disableEnableUser = createAsyncThunk(
    'disable user by id',
    async (payload: any, { dispatch }) => {
        console.log(payload)
        await fetch(`${endpoints.disableEnableUser}${payload?.userId}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
        }).then((response) => {
            return response.json();
        }).then((data) => {
            // console.log(data)
            if (data.statusCode === 200) {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: data.errorMsg
                }))
                // dispatch(getUserList(""))
                dispatch(getUserAmount())
                dispatch(getUserDetails(payload?.publicUserId))
            } else {
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: data.errorMsg
                }))
            }

        }).catch((err) => {
            console.log(err);
            return err;
        })

    }
)

export const addMoneyToUserWallet = createAsyncThunk(
    'add money to user wallet',
    async (payload: any, { dispatch }) => {
        dispatch(toggleLoader({
            isLoading: true
        }))
        // console.log(payload)
        await fetch(endpoints.editUserWallet, {
            method: "PUT",
            body: JSON.stringify(payload),
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.statusCode === 200) {
                dispatch(toggleLoader({
                    isLoading: false
                }))
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.success,
                    message: data.errorMsg
                }))
                dispatch(getUserAmount());
                dispatch(getUserDetails(payload?.userId))
            } else {
                dispatch(toggleLoader({
                    isLoading: false
                }))
                dispatch(toggleNotificationVisibility({
                    isVisible: true,
                    status: NotificationType.error,
                    message: data.errorMsg
                }))
            }
            // console.log(data)
        }).catch((error) => {
            return error;
        })
    }
)

const usersSlice = createSlice({
    name: 'users slice',
    initialState: usersInitialState,
    reducers: {
        setUserList: (state, action: PayloadAction<SetUserListProps>) => {
            return {
                ...state,
                users: action.payload.data
            }
        },
        setUserAmount: (state, action: PayloadAction<SetUserListProps>) => {
            return {
                ...state,
                userAmount: action.payload.data
            }
        },
        setUserDetails: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                useDetail: action.payload.data
            }
        }
    }
});

export const { setUserList, setUserAmount, setUserDetails } = usersSlice.actions;
export default usersSlice.reducer